(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".media-banner__heading");

    if (!text) return;

    /* Reveal unification Stage 4, trigger line retuned (owner request): the old ScrollTrigger
       parity line was "50% 95%" — midpoint at 95% of the viewport, i.e. the heading revealed
       almost exactly at the bottom edge. The owner wants subheadings to reveal in the natural
       reading band instead: midpoint crossing 85% of the viewport (lower-middle). */
    if (window.CoyReveal) {
      CoyReveal.observeAt(text, 0.5, 0.85);
    } else {
      text.classList.add("animated"); /* utility missing: settle immediately, never hidden */
    }
  };

  initAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
  });
})();